(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/draw.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/draw.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
svs.numbergames.game.utils.createGameDraw = _ref => {
  let {
    product,
    draws
  } = _ref;
  if (draws && !svs.numbergames.game.draw) {
    const DrawClass = "".concat(svs.numbergames.productMapping.getProductName(product) || '', "Draw");
    svs.numbergames.game.draw = new svs.numbergames.draws[DrawClass](draws);
  }
};
svs.numbergames.game.utils.updateDrawData = _ref2 => {
  let {
    productId
  } = _ref2;
  if (!productId) return;
  const deferred = $.Deferred();
  const productDraw = svs.numbergames.productMapping.getProductDrawId(productId);
  const productName = svs.numbergames.productMapping.getProductName(productId);
  const isLotto = svs.numbergames.productMapping.isLotto(productId);
  const isVikinglotto = svs.numbergames.productMapping.isVikinglotto(productId);
  const path = "/draw/1/".concat(productDraw, "/draws");
  const options = {
    path,
    method: 'GET'
  };
  if (isLotto || isVikinglotto) {
    const paths = [path, '/draw/1/jokerwednesday/draws'];
    if (isLotto) paths.push('/draw/1/jokersaturday/draws');
    options.path = "/multifetch?urls=".concat(encodeURI(paths.join('|')));
  }
  svs.core.jupiter.call(options, success => {
    let drawData = success.draw;
    let drawsJokerWed;
    let drawsJokerSat;
    if (success.responses) {
      const {
        responses
      } = success;
      drawData = responses[0].draw || responses[0].draws;
      drawsJokerWed = responses[1].draw;
      if (responses[2]) drawsJokerSat = responses[2].draw;
    }
    svs.numbergames.game.draw = new svs.numbergames.draws["".concat(productName || '', "Draw")](_objectSpread(_objectSpread({}, drawData), {}, {
      drawsJokerWed,
      drawsJokerSat
    }));
    svs.numbergames.game.logger.debug("svs.numbergames.game.draw updated with", _objectSpread(_objectSpread({}, drawData), {}, {
      drawsJokerWed,
      drawsJokerSat
    }));
    deferred.resolve();
  }, error => {
    svs.numbergames.game.logger.warn("Request to ".concat(options.path, " responded with error!"), error);
    deferred.reject(error);
  });
  return deferred.promise();
};
 })(window);